export const TRIPS_SIDEBAR_EXPANDED_WIDTH_PX = 320
export const TRIPS_SIDEBAR_COLLAPSED_WIDTH_PX = 56
